module.exports = __webpack_public_path__ + "img/yaddrx2.7c05e03d.jpg";